@if (forSignup()) {
    <ng-container *ngTemplateOutlet="content" />
} @else {
    <div
        class="click-wrapper"
        [class.is-open]="nzDropdown.nzVisible"
        nz-dropdown
        nzTrigger="click"
        nzPlacement="bottomRight"
        [nzClickHide]="false"
        [nzDropdownMenu]="menu"
        #nzDropdown="nzDropdown"
    >
        <adspt-icon
            [nz-tooltip]="'common.select-customer' | translate"
            nzTooltipPlacement="left"
            class="adspt-customer-select"
            name="customer-select"
            class="p3"
        />
    </div>

    <nz-dropdown-menu #menu="nzDropdownMenu">
        <ng-container *ngTemplateOutlet="content" />
    </nz-dropdown-menu>
}

<ng-template #content>
    <div class="customer-selection-dialog-wrapper a-fx-col" [ngClass]="{ signup: forSignup() }">
        <div class="tab-contents a-fx-col">
            <div class="tab-content one a-fx-col">
                @if (forSignup()) {
                    <h4 class="a-fx-none">{{ 'common.select-customer-info' | translate }}</h4>
                } @else {
                    <div class="items selected a-fx-none" role="list">
                        <div role="listitem" class="item">
                            <h3>{{ 'common.selected-customer' | translate }}: {{ customer()?.name }}</h3>
                        </div>
                    </div>
                }
                <div class="search-wrapper a-fx-none">
                    <nz-input-group [nzPrefix]="prefixIconSearch">
                        <input
                            type="text"
                            nz-input
                            [placeholder]="'common.search-customers' | translate"
                            (input)="customersMutator.searchTerm$.next(input.value)"
                            #input
                        />
                    </nz-input-group>
                    <ng-template #prefixIconSearch>
                        <adspt-icon name="zoom" />
                    </ng-template>
                </div>
                @switch (loadState()) {
                    @case (0) {
                        <div class="no-data a-fx-auto">
                            <p class="p2 title">{{ 'common.no-data' | translate }}</p>
                        </div>
                    }
                    @case (-1) {
                        <div class="error-state a-fx-none">
                            <p class="p2">{{ 'common.error-msg' | translate }}</p>
                        </div>
                    }
                    @case (1) {
                        <div class="title a-fx-auto">
                            <p class="subtitle">
                                {{ 'common.list-of-customers' | translate }} ({{ customersMutator.total$ | async }})
                            </p>
                            <nz-spin
                                nzSimple
                                nzSize="small"
                                *ngIf="(customersMutator.loading$ | async) && !(customersMutator.loadingMore$ | async)"
                            ></nz-spin>
                        </div>
                        <div class="items a-fx-auto" (scroll)="onScroll($event)" role="list">
                            @for (item of formatedCustomers(); track item.customerId; let i = $index) {
                                <a
                                    role="listitem"
                                    class="item"
                                    tabindex="{{ i }}"
                                    [href]="item.url"
                                    [class.selected]="customer()?.customerId === item.customerId"
                                >
                                    <h3>
                                        {{ item.name }} - <small>{{ item.customerId }}</small>
                                    </h3>
                                </a>
                            }
                        </div>
                    }
                }
            </div>

            @if (customersMutator.loadingMore$ | async) {
                <div class="progress-wrapper">
                    <nz-spin nzSimple></nz-spin>
                </div>
            }
        </div>
    </div>
</ng-template>
